import * as type from './mutation-type.js'

export const changeloginstate = ({
  commit,
  state
}, isLogined) => {
  commit(type.CHANGE_LOGIN_STATE, isLogined)
}
export const login = ({
  commit,
  state
}, token) => {
  commit(type.LOGIN, token)
}
export const user = ({
  commit,
  state
}, obj) => {
  commit(type.USER, obj)
}
export const logout = ({
  commit,
  state
}) => {
  commit(type.LOGOUT)
}

export const menuTheme = ({
  commit
}, obj) => {
  commit(type.MENU_THEME, obj)
}
